import React, { useState } from 'react';
import { toolService } from '../../../services';

export function IpLookupSection({ label }) {
  const [ip, setIp] = useState('');
  const [resultHtml, setResultHtml] = useState(''); // will hold HTML
  const [copied, setCopied] = useState(false);

  // IP validation from your backend code
  const validateIP = (ip) => {
    const ipRegex =
      /^(25[0-5]|2[0-4][0-9]|1[0-9][0-9]|[1-9]?[0-9])(\.(25[0-5]|2[0-4][0-9]|1[0-9][0-9]|[1-9]?[0-9])){3}$/;
    return ipRegex.test(ip);
  };

  const runLookup = async () => {
    setCopied(false);

    if (!validateIP(ip)) {
      setResultHtml('<b>Invalid IP Address!</b>');
      return;
    }

    try {
      const data = await toolService.whoisLookup(ip);
      const logo = data.logo || 'generic_logo.png';
      const logoBaseUrl = process.env.REACT_APP_ISP_LOGO_BASE_URL || 'https://www.whois.nginx.encasa/img/us_isp_logos';
      const logoUrl = `${logoBaseUrl}/${logo}`;

      const formattedOutput = `
        <b>IP Address: ${ip}</b><br><br>
        ${JSON.stringify(data.output).replace(/\n/g, '<br>')}<br><br>
        <div style="text-align:center">
          <img src="${logoUrl}" alt="ISP Logo" style="max-height:80px; margin-top:10px;" />
        </div>
      `;
      setResultHtml(formattedOutput);
    } catch (error) {
      setResultHtml(`<b>Error:</b> ${error.message}`);
    }
  };

  const clearForm = () => {
    setIp('');
    setResultHtml('');
    setCopied(false);
  };

  const copyToClipboard = () => {
    const tempDiv = document.createElement('div');
    tempDiv.innerHTML = resultHtml;
    const text = tempDiv.innerText;

    navigator.clipboard.writeText(text).then(() => {
      setCopied(true);
      setTimeout(() => setCopied(false), 3000);
    });
  };

  return (
    <div className="bg-white shadow p-6 rounded-lg max-w-md w-full text-black space-y-4">
      <h3 className="text-xl font-semibold">{label}</h3>

      <label htmlFor={`ipAddress-${label}`} className="block font-medium">
        Enter IP Address:
      </label>

      <input
        type="text"
        id={`ipAddress-${label}`}
        placeholder="e.g., 8.8.8.8"
        value={ip}
        onChange={(e) => setIp(e.target.value)}
        className="w-full border border-gray-300 rounded px-3 py-2 focus:outline-none focus:ring-2 focus:ring-blue-500 uppercase"
      />

      <div className="flex gap-2">
        <button
          onClick={runLookup}
          className="bg-blue-600 text-white px-4 py-2 rounded hover:bg-blue-700"
        >
          Run Lookup
        </button>

        <button
          onClick={clearForm}
          className="bg-gray-300 text-black px-4 py-2 rounded hover:bg-gray-400"
        >
          Clear
        </button>
      </div>

      <div
        id={`result-${label}`}
        className="bg-gray-100 p-3 rounded border border-gray-300 min-h-[48px] text-sm overflow-auto"
        dangerouslySetInnerHTML={{ __html: resultHtml }}
      />

      <button
        onClick={copyToClipboard}
        className="bg-green-600 text-white px-4 py-2 rounded hover:bg-green-700"
      >
        Copy to Clipboard
      </button>

      {copied && (
        <span
          id={`copyMessage-${label}`}
          className="text-green-600 font-medium block"
        >
          ✔ Copied!
        </span>
      )}
    </div>
  );
}
